<div class="ids-mb-4 ids-mt-8">
  <p class="ids-mb-4 ids-label -bold ids-color-text-heading-1">{{cnpjSeller ? ('percentual de ' + sellersPercentage?.name) : 'seu percentual'}}</p>
  <p>{{cnpjSeller ? 'Informe a porcentagem do imóvel que cada representantes ou procuradores irão receber' : 'Pessoas casadas ou em união estável devem informar também o percentual do imóvel que o cônjuge vai receber'}}</p>
</div>

<ol idsList class="ids-pb-10">

  <li idsLi *ngFor="let user of sellersPercentage?.accounts; let i = index">
    <span idsLiText>{{ changeNameSeller(user) }}</span>
    <span idsLiSubText>{{ getBankNameFromBackend(user.bankNumber) }} | ag {{ user.agencyNumber }} cc {{ user.accountNumber }}</span>
    <span idsLiDescription class="ids-stamp ids-stamp--outline">
      <div class="input-container">
        <input
          class="custom-input"
          [(ngModel)]="user.percentage"
          maxlength="6"
          type="text"
          (input)="onPercentInput($event, i)"
        />
      </div>
    </span>
  </li>
</ol>
